import { Inject, Injectable } from '@angular/core';
import { PartnerServiceInterface } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { PARTNER_ID } from '../tokens';

@Injectable({ providedIn: 'root' })
export class PartnerService implements PartnerServiceInterface {
  constructor(@Inject(PARTNER_ID) private partnerId$: Observable<string>) {}
  public getPartnerId(): Observable<string> {
    return this.partnerId$;
  }
}
